import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';
import OTButton from '../tag/OTButton';
import OTIcon from '../tag/OTIcon';
import BioBankHeader from './BioBankHeader';
import Collapsible from 'react-collapsible';
import WindowUtils from '../../utils/WindowUtils';
import { BIOBANK, USER } from '../../data/reducer';
import { BIOBANK_STATUS } from '../../definitions/BioBankConstants';
import Loader from '../Loader';
import { selectIsHpa } from '../../data/hpa/selectors';
import { withRouter } from 'react-router-dom';
import { OTLink } from '../tag/OTLink';

var moment = require('moment');
const { id: module_id } = module;

class BiobankAgreementView extends React.Component {
  areButtonsDisabled = () => {
    let { isHpa, bioBankApplicable } = this.props;
    return isHpa || !bioBankApplicable;
  };

  renderRefusalView() {
    let {
      consentData: { validFrom },
      revokeRefusal,
      openRefusal,
    } = this.props;
    let buttonsDisabled = this.areButtonsDisabled();
    return (
      <div>
        <div className="biobank_container">
          <div className="biobank_container_content">
            <h2
              className="biobank_subheading biobank_blue"
              style={{ paddingBottom: '10px' }}
            >
              <i className="icon-ban-circle" style={{ marginRight: '10px' }} />
              <FormattedMessage
                id={`${module_id}.refusal.done`}
                values={{
                  created: moment(validFrom).format('DD.MM.YYYY'),
                }}
              />
            </h2>
            <p>
              <FormattedMessage id={`${module_id}.refusal.content`} />
            </p>
          </div>
          <div className="biobank_container_content_button">
            <OTButton
              className={'ot-button--light'}
              key="submit"
              onClick={openRefusal}
              disabled={buttonsDisabled}
            >
              <FormattedMessage id={`open.refusal`} />
            </OTButton>
          </div>
        </div>
        <hr />
        <div className="biobank_container">
          <div className="biobank_container_content">
            <h2 className="biobank_subheading">
              <FormattedMessage id={`${module_id}.agreement.consent.title`} />
            </h2>
            <p>
              <FormattedMessage id={`${module_id}.agreement.consent.content`} />
            </p>
            <p className="biobank_agreement_link">
              <a
                href="https://www.pirha.fi/tampereen-biopankin-henkilotietorekisteri"
                target="_blank"
              >
                Lue lisää Tampereen Biopankin henkilötietorekisteristä
              </a>
            </p>
          </div>
          <div className="biobank_container_content_button">
            <OTButton
              className={'ot-button--light'}
              key="agree"
              onClick={revokeRefusal}
              disabled={buttonsDisabled}
            >
              <FormattedMessage id={`give.consent`} />
            </OTButton>
          </div>
        </div>
      </div>
    );
  }

  renderNoneView() {
    let { consent, refusal } = this.props;
    let buttonsDisabled = this.areButtonsDisabled();
    return (
      <div>
        <div className="ingress">
          <FormattedMessage id={`${module_id}.no.agreement`} />
        </div>
        <hr />
        <div className="biobank_container">
          <div className="biobank_container_content">
            <h2 className="biobank_subheading">
              <FormattedMessage id={`${module_id}.agreement.consent.title`} />
            </h2>
            <p>
              <FormattedMessage id={`${module_id}.agreement.consent.content`} />
            </p>
            <p className="biobank_agreement_link">
              <a
                href="https://www.pirha.fi/tampereen-biopankin-henkilotietorekisteri"
                target="_blank"
              >
                Lue lisää Tampereen Biopankin henkilötietorekisteristä
              </a>
            </p>
          </div>
          <div className="biobank_container_content_button">
            <OTButton
              className={'ot-button--light'}
              key="agree"
              onClick={consent}
              disabled={buttonsDisabled}
            >
              <FormattedMessage id={`give.consent`} />
            </OTButton>
          </div>
        </div>
        <div className="biobank_container">
          <div className="biobank_container_content">
            <h2 className="biobank_subheading">
              <FormattedMessage id={`${module_id}.agreement.refusal.title`} />
            </h2>
            <p>
              <FormattedMessage id={`${module_id}.agreement.refusal.content`} />
            </p>
          </div>
          <div className="biobank_container_content_button">
            <OTButton
              className={'ot-button--light'}
              key="submit"
              onClick={refusal}
              disabled={buttonsDisabled}
            >
              <FormattedMessage id={`make.refusal`} />
            </OTButton>
          </div>
        </div>
      </div>
    );
  }

  renderConsentView() {
    let {
      consentData: { validFrom },
      consent,
      refusal,
    } = this.props;
    let buttonsDisabled = this.areButtonsDisabled();
    return (
      <div>
        <div className="biobank_container">
          <div className="biobank_container_content">
            <p className="biobank_subheading biobank_green">
              <i className="icon-ok" style={{ marginRight: '10px' }} />
              <FormattedMessage
                id={`${module_id}.agreement.consent.done.title`}
                values={{
                  created: moment(validFrom).format('DD.MM.YYYY'),
                }}
              />
            </p>
            <FormattedMessage
              id={`${module_id}.agreement.consent.done.content`}
            >
              {(txt) => <p>{txt}</p>}
            </FormattedMessage>

            <OTLink
              className="biobank_agreement_link"
              isExternal={true}
              target="_blank"
              link={
                'https://www.pirha.fi/tampereen-biopankin-henkilotietorekisteri'
              }
            >
              <FormattedMessage id={`${module_id}.read.more.about.biobank`}>
                {(txt) => <>{txt}</>}
              </FormattedMessage>
              <OTIcon
                config={{
                  type: 'fa',
                  name: 'icon-external-link',
                  color: 'default',
                }}
              />
            </OTLink>
          </div>
          <div className="biobank_container_content_button">
            <OTButton
              className={'ot-button--light'}
              key="agree"
              onClick={consent}
              disabled={buttonsDisabled}
            >
              <FormattedMessage id={`open.consent`} />
            </OTButton>
          </div>
        </div>
        <hr />
        <div className="biobank_container">
          <div className="biobank_container_content">
            <h2 className="biobank_subheading">
              <FormattedMessage id={`${module_id}.agreement.refusal.title`} />
            </h2>
            <p>
              <FormattedMessage
                id={`${module_id}.agreement.refusal.done.content`}
              />
            </p>
          </div>
          <div className="biobank_container_content_button">
            <OTButton
              className={'ot-button--light'}
              key="submit"
              onClick={refusal}
              disabled={buttonsDisabled}
            >
              <FormattedMessage id={`make.refusal`} />
            </OTButton>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { consentData, isHpa } = this.props;

    if (!consentData && !isHpa) return <Loader />;

    if (isHpa) {
      return this.renderNoneView();
    }

    switch (consentData.status || consentData.documentType) {
      case BIOBANK_STATUS.REFUSAL:
        return this.renderRefusalView();
      case BIOBANK_STATUS.CONSENT:
        return this.renderConsentView();
      case BIOBANK_STATUS.NONE:
        return this.renderNoneView();
      default:
        return <Loader />;
    }
  }
}

class BioBankAgreementInfo extends React.Component {
  consent = () => {
    let { history, consentData } = this.props;
    if (consentData.status === BIOBANK_STATUS.NONE) {
      history.push('/biobank/consent/latest/1');
    } else {
      history.push('/biobank/consent/current/1');
    }
  };

  revokeRefusal = (event) => {
    event.preventDefault();
    this.props.triggerConsentModal();
  };

  refusal = (event) => {
    event.preventDefault();
    this.props.triggerRefusalModal();
  };

  openRefusal = () => {
    let { history } = this.props;
    history.push('/biobank/refusal');
  };

  render() {
    let { consentData, isHpa, bioBankApplicable } = this.props;

    return (
      <div className="biobank">
        <Collapsible
          open={true}
          className="ot-collapsible ot-maincontainer biobank_agreement_t"
          openedClassName="ot-collapsible ot-maincontainer"
          trigger={<BioBankHeader />}
        >
          <BiobankAgreementView
            consent={this.consent}
            refusal={this.refusal}
            revokeRefusal={this.revokeRefusal}
            openRefusal={this.openRefusal}
            consentData={consentData}
            isHpa={isHpa}
            bioBankApplicable={bioBankApplicable}
          />
        </Collapsible>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    consentData: state[BIOBANK].consentData.data,
    userInfo: state[USER].userInfo,
    relatives: state[USER].relatives,
    isHpa: selectIsHpa(state),
  };
};

export default connect(mapStateToProps)(withRouter(BioBankAgreementInfo));
